import { c as _c } from "react-compiler-runtime";
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const LoggerContext = /*#__PURE__*/createContext(null);
export const ProvideLogger = t0 => {
  const $ = _c(3);
  const {
    logger,
    children
  } = t0;
  if (!logger) {
    throw new Error("logger is not defined within ProvideLogger");
  }
  let t1;
  if ($[0] !== children || $[1] !== logger) {
    t1 = /*#__PURE__*/_jsx(LoggerContext.Provider, {
      value: logger,
      children: children
    });
    $[0] = children;
    $[1] = logger;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useLogger = () => {
  return useContext(LoggerContext);
};